<template>
  <span class="pa-0">
    <span
      v-for="(schemaValue, schemaKey) in schema"
      :key="schemaKey"
      class="pa-0"
    >
      <LeefType
        v-if="typeof schemaValue === 'object' && schemaValue.type !== undefined"
        v-model="cloneRequestSchema[schemaKey]"
        :schema-key="schemaKey"
        :schema-value="schemaValue"
      />
      <Tree
        v-else-if="typeof schemaValue === 'object'"
        v-model="cloneRequestSchema[schemaKey]"
        :schema-key="schemaKey"
        :schema="schemaValue"
      />
      <LeefType
        v-else
        v-model="cloneRequestSchema[schemaKey]"
        :schema-key="schemaKey"
        :schema-value="{ type: schemaValue }"
      />
    </span>
  </span>
</template>

<script>
import Tree from './Tree'
import LeefType from './LeefType'
import { cloneDeep } from 'lodash'

export default {
  components: {
    Tree,
    LeefType
  },

  props: ['schema', 'value'],

  data() {
    return {
      cloneRequestSchema: undefined
    }
  },

  computed: {
    isRequestSchemaUndefined() {
      return Object.values(this.cloneRequestSchema).every(v => !v)
    }
  },

  watch: {
    cloneRequestSchema: {
      deep: true,
      handler() {
        // if (this.isRequestSchemaUndefined) this.cloneRequestSchema = undefined
        this.$emit('input', this.cloneRequestSchema)
      }
    }
  },
  created() {
    this.cloneRequestSchema = cloneDeep(this.value)
    if (this.cloneRequestSchema === undefined) this.cloneRequestSchema = {}
  }
}
</script>

<style></style>
